/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Upload_Media_FileInputs */



/**
* | output |
* | --- |
* | "Failed to upload media file" |
*
* @param {Failed_To_Upload_Media_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_upload_media_file = /** @type {((inputs?: Failed_To_Upload_Media_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Upload_Media_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du téléversement du fichier média")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mediendatei konnte nicht hochgeladen werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare il file multimediale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось загрузить медиафайл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo cargar el archivo multimedia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体文件上传失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアファイルのアップロードに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया फ़ाइल अपलोड करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao carregar o arquivo de mídia")
	return /** @type {LocalizedString} */ ("Failed to upload media file")
});